export default {
  VOLUNTARY_SCHEME: 'VOLUNTARY_SCHEME',
  SCHEME_FOR_MEMBER: 'SCHEME_FOR_MEMBER',
  SHEME_FOR_ANOTHER_COUNTRY: 'SHEME_FOR_ANOTHER_COUNTRY',
  UNCERTIFIED: 'UNCERTIFIED',
};
